import { useState, useEffect } from 'react';
import Input from '@/components/ui/Input';
import Select from '@/components/ui/Select';
import Button from '@/components/ui/Button';
import {
  NATURE_AJUSTEMENT_OPTIONS,
  SENS_AJUSTEMENT_OPTIONS,
  TYPE_AJUSTEMENT_OPTIONS,
} from '@/constants/enums';

export default function AjustementFormModal({ ajustement, onSave, onCancel }) {
  const [form, setForm] = useState({
    nature: '',
    sens: '',
    type_ajustement: '',
    valeur: '',
    justification: '',
  });

  useEffect(() => {
    if (ajustement) {
      setForm({
        nature: ajustement.nature ?? '',
        sens: ajustement.sens ?? '',
        type_ajustement: ajustement.type_ajustement ?? '',
        valeur: ajustement.valeur ?? '',
        justification: ajustement.justification ?? '',
      });
    }
  }, [ajustement]);

  const handleChange = (field) => (e) => setForm((f) => ({ ...f, [field]: e.target.value }));

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave({
      ...form,
      valeur: form.valeur === '' ? 0 : Number(form.valeur),
    });
  };

  const isEdit = !!ajustement;
  const valeurLabel =
    form.type_ajustement === 'pourcentage'
      ? 'Valeur (%)'
      : form.type_ajustement === 'montant'
        ? 'Valeur (€)'
        : 'Valeur';

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      <div className="bg-white rounded-xl shadow-xl w-full max-w-lg mx-4 p-6">
        <h3 className="text-lg font-semibold text-slate-900 mb-4">
          {isEdit ? 'Modifier l\'ajustement' : 'Ajouter un ajustement'}
        </h3>

        <form onSubmit={handleSubmit} className="space-y-4">
          <Select
            label="Nature"
            name="nature"
            value={form.nature}
            options={NATURE_AJUSTEMENT_OPTIONS}
            onChange={handleChange('nature')}
            required
          />
          <Select
            label="Sens"
            name="sens"
            value={form.sens}
            options={SENS_AJUSTEMENT_OPTIONS}
            onChange={handleChange('sens')}
            required
          />
          <Select
            label="Type d'ajustement"
            name="type_ajustement"
            value={form.type_ajustement}
            options={TYPE_AJUSTEMENT_OPTIONS}
            onChange={handleChange('type_ajustement')}
            required
          />
          <Input
            label={valeurLabel}
            name="valeur"
            type="number"
            value={form.valeur}
            onChange={handleChange('valeur')}
            required
          />
          <Input
            label="Justification"
            name="justification"
            type="textarea"
            value={form.justification}
            onChange={handleChange('justification')}
          />

          <div className="flex justify-end gap-3 pt-2">
            <Button type="button" variant="secondary" onClick={onCancel}>
              Annuler
            </Button>
            <Button type="submit" variant="primary">
              {isEdit ? 'Modifier' : 'Ajouter'}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
}
